import React from 'react';
import { useSelector } from 'react-redux';
import AboutUsSection from '../../components/about/AboutUS';
import FaqSection from '../../components/about/FAQ';
import Form from '../../components/contactform/Form';

const translations = {
  gb: {
    heading: 'Contact Us',
    buttonText: 'About Us',
  },
  sa: {
    heading: 'اتصل بنا',
    buttonText: 'معلومات عنا',
  },
  fr: {
    heading: 'Contactez-nous',
    buttonText: 'À propos de nous',
  },
  de: {
    heading: 'Kontaktiere uns',
    buttonText: 'Über uns',
  },
};

const Contact = () => {
  const { language } = useSelector((state) => state.language);
  const currentLang = translations[language] || translations.gb;

  return (
    <>
      <AboutUsSection
        heading={currentLang.heading}
        buttonText={currentLang.buttonText}
      />
      <Form />
      <FaqSection />
    </>
  );
};

export default Contact;
